import { lazy } from 'react';

const HomePage = lazy(() => import('./HomePage'))
const UploadPage = lazy(() => import('./UploadPage'))
const ConfigPage = lazy(() => import('./ConfigPage'))
const ResultsPage = lazy(() => import('./ResultsPage'))
const DetailPage = lazy(() => import('./DetailPage'))
const ServiceLayout = lazy(() => import('./ServiceLayout'))
const ServiceTaskLayout = lazy(() => import('./ServiceTaskLayout'))

const Service = {
    HomePage,
    UploadPage,
    ConfigPage,
    ResultsPage,
    DetailPage,
    Layout: ServiceLayout,
    TaskLayout: ServiceTaskLayout,
}

export default Service